import { httpClient } from '@/network/clientController'

/** Check for Updates
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internethealthcheckversion
*/
export const checkForUpdates = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'healthcheck/version',
		params: payload
	})
}
